import React from 'react'
import { useTranslation } from 'react-i18next'
import './UnexpectedError.css'

type Props = {}

const UnexpectedError: React.FC<Props> = () => {
  const { t } = useTranslation()

  return (
    <div id="unexpected-error" style={{ flexDirection: 'column' }}>
      <section className="unexpected-error-block">
        <div className="row no-gutters align-items-center">
          <div className="col-12 unexpected-error-content p-4">
            <h1>Oops!</h1>
            {t('messages.generalErrorMsg')}
          </div>
        </div>
      </section>
      <div aria-hidden="true" className="plaintext-button">
        <span aria-hidden="true" onClick={() => { window.history.back() }}>
          {t('actions.reloadPage')}
        </span>
      </div>
    </div>
  )
}

export default UnexpectedError
